import React from "react";

export default function Header() {
  return (
    <nav className="navbar">
      <img src="../images/logo.png"></img>
      <h4 className="nav-text">my travel journal.</h4>
    </nav>
  );
}
